import Tibbits from '@appblocks/codegeneration/Tibbits';
import {
    BlockType,
    CodeBlock,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import * as simulator from './simulator';
import * as tios from './tios';


export default class Tibbit_28 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_28';
        this.name = 'Tibbit 28';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt28/tbt28.tbh',
            'libraries/tibbits/tbt28/tbt28.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'LIGHT_NAME',
                name: 'Light Intensity Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): Array<CodeBlock> {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
